export enum ANNOTATION_ID {
  // CREW ANNOTATION INFO
  /** お客さまが現在使用されているモバイル端末の契約期間満了月・更新年月を設定\n設定した月の半年前になると、復活予定状態から再度閲覧可能な状態に戻る */
  ANTT_I_1 = 1,
  /** お客さまが現在使用されているモバイル端末にキャンペーン(トクサポ)が適用される年月日を設定\n設定した日の半年前になると、復活予定状態から再度閲覧可能な状態に戻る */
  ANTT_I_2 = 2,
  /** お客さまが現在使用されているモバイル端末の機種代金の分割支払いが終了になる年月を設定\n設定した月の半年前になると、復活予定状態から再度閲覧可能な状態に戻る */
  ANTT_I_3 = 3,
  /** お客さまが現在契約されているSB光の更新年月を設定\n設定した月の半年前になると、復活予定状態から再度閲覧可能な状態に戻る */
  ANTT_I_4 = 4,
  /** お客さまが現在契約されているSBAirの更新年月を設定\n設定した月の半年前になると、復活予定状態から再度閲覧可能な状態に戻る */
  ANTT_I_5 = 5,
  /** このアクションを行う商品を選択\nダッシュボードのレポート画面ではアクションと紐付けられている商品を集計 */
  ANTT_I_6 = 6,
  /** 【件数】レポートの商談中の件数＋商品未登録の商談数を集計\n人数】レポートの商談中の人数＋商談未登録の顧客数を集計 */
  ANTT_I_7 = 7,
  /** 【商談中】\n商談ステータスが未入力 ・商談中・提案前、対応ステータスが未入力・対応中・可能性ありの商品のうち、\nアクション予定日が翌々月以降のものを除いた商品数を集計\n\n【長期保留】\n商談ステータスが未入力 ・商談中・提案前、対応ステータスが未入力・対応中・可能性ありの商品のうち、\n・アクション予定日が翌々月の1日から4か月後の最終日以内\n・復活予定\nの合計商品数を集計\n\n【商談終了】\n商談ステータスが契約成立・契約不成立・利用中、対応ステータスが対応完了の商品数を集計 */
  ANTT_I_8 = 8,
  /** 商談ステータスが未入力 ・商談中・提案前の商品のうち、アクション予定日が翌々月以降のものを除いた商品を含む商品数・顧客数を集計 */
  ANTT_I_9 = 9,
  /** 商談ステータスが未入力 ・商談中・提案前の商品のうち、アクション予定日が翌々月の1日から4か月後の最終日以内または復活予定の商品を含む商品数・顧客数を集計 */
  ANTT_I_10 = 10,
  /** 商談ステータスが契約成立・契約不成立・利用中の商品を含む商品数・顧客数を集計 */
  ANTT_I_11 = 11,

  // AGENCY ANNOTATION INFO
  /** 【件数】レポートの商談中の件数＋商品未登録の商談数を集計\n【人数】レポートの商談中の人数＋商談未登録の顧客数を集計 */
  ANTT_I_12 = 12,
  /** 【商談中】\n商談ステータスが未入力 ・商談中・提案前、対応ステータスが未入力・対応中・可能性ありの商品のうち、\nアクション予定日が翌々月以降のものを除いた商品数を集計\n\n【長期保留】\n商談ステータスが未入力 ・商談中・提案前、対応ステータスが未入力・対応中・可能性ありの商品のうち、\n・アクション予定日が翌々月の1日から4か月後の最終日以内\n・復活予定\nの合計商品数を集計\n\n【商談終了】\n商談ステータスが契約成立・契約不成立・利用中、対応ステータスが対応完了の商品数を集計 */
  ANTT_I_13 = 13,
  /** 商談ステータスが未入力 ・商談中・提案前の商品のうち、アクション予定日が翌々月以降のものを除いた商品を含む商品数・顧客数を集計 */
  ANTT_I_14 = 14,
  /** 商談ステータスが未入力 ・商談中・提案前の商品のうち、アクション予定日が翌々月の1日から4か月後の最終日以内または復活予定の商品を含む商品数・顧客数を集計 */
  ANTT_I_15 = 15,
  /** 商談ステータスが契約成立・契約不成立・利用中の商品を含む商品数・顧客数を集計 */
  ANTT_I_16 = 16,

  // EMPLOYEE ANNOTATION INFO
  /** 【件数】レポートの商談中の件数＋商品未登録の商談数を集計\n【人数】レポートの商談中の人数＋商談未登録の顧客数を集計 */
  ANTT_I_17 = 17,
  /** 【商談中】\n商談ステータスが未入力 ・商談中・提案前、対応ステータスが未入力・対応中・可能性ありの商品のうち、\nアクション予定日が翌々月以降のものを除いた商品数を集計\n\n【長期保留】\n商談ステータスが未入力 ・商談中・提案前、対応ステータスが未入力・対応中・可能性ありの商品のうち、\n・アクション予定日が翌々月の1日から4か月後の最終日以内\n・復活予定\nの合計商品数を集計\n\n【商談終了】\n商談ステータスが契約成立・契約不成立・利用中、対応ステータスが対応完了の商品数を集計 */
  ANTT_I_18 = 18,
  /** 商談ステータスが未入力 ・商談中・提案前の商品のうち、アクション予定日が翌々月以降のものを除いた商品を含む商品数・顧客数を集計 */
  ANTT_I_19 = 19,
  /** 商談ステータスが未入力 ・商談中・提案前の商品のうち、アクション予定日が翌々月の1日から4か月後の最終日以内または復活予定の商品を含む商品数・顧客数を集計 */
  ANTT_I_20 = 20,
  /** 商談ステータスが契約成立・契約不成立・利用中の商品を含む商品数・顧客数を集計 */
  ANTT_I_21 = 21,
  /** お客さまが現在契約されているSoftbank 光＋の更新年月を設定\n設定した月の半年前になると、復活予定状態から再度閲覧可能な状態に戻る */
  ANTT_I_22 = 22,
  /** お客さまが現在契約されているおうちのでんわの更新年月を設定\n設定した月の半年前になると、復活予定状態から再度閲覧可能な状態に戻る */
  ANTT_I_23 = 23,
}

export default ANNOTATION_ID;
